import {Injectable} from '@angular/core';
import {CustomJsonDataService, DcpSubtotalGroups} from '@dcp/configurator';
import {Cart} from '@spartacus/cart/base/root';
import {CommonError} from '../../model/error/common-error.model';

@Injectable({
  providedIn: 'root',
})
export class CartDataService {
  constructor(protected dataService: CustomJsonDataService) {
  }

  public getPriceTotalsByContract(cart: Cart): DcpSubtotalGroups[] {
    return this.dataService.getDataFieldOfType(cart, 'priceTotalsByContract');
  }

  public getPriceTotalsBySalesArea(cart: Cart): {} {
    return this.dataService.getDataFieldOfType(cart, 'priceTotalsBySalesArea');
  }

  public getErrorDetails(cart: Cart): CommonError {
    return this.dataService.getDataFieldOfType(cart, 'errorDetails');
  }
}
